export const TIMESLOT_STEP = 25;
export const MINUTES_PER_INCREMENT = 30;
